class Footer {
	constructor() {
		this._init();
	}
	_init() {

		$(document).ready(function() {
			$('body').on('click', '[name="subscribe"], [name="goto_pp"], [name="goto_gc"]', function(e) {

				var related_checkbox = $('#'+e.target.getAttribute('check-rel'));

				if(related_checkbox.length) {
					if (!related_checkbox.is(':checked')) {
						alert("You must agree with the terms and conditions of sales to check out.");
						return false;
					}
				}
			});
		});
	}
}

export default Footer;
